
import { CheckCircle, AlertCircle } from 'lucide-react';

export const getValidationIcon = (status: string) => {
  switch (status) {
    case 'valid':
      return CheckCircle;
    case 'incomplete':
      return AlertCircle;
    case 'invalid':
      return AlertCircle;
    default:
      return AlertCircle;
  }
};

export const getValidationIconColor = (status: string) => {
  switch (status) {
    case 'valid':
      return 'text-green-600';
    case 'incomplete':
      return 'text-yellow-600';
    case 'invalid':
      return 'text-red-600';
    default:
      return 'text-gray-600';
  }
};

export const getValidationColor = (status: string) => {
  switch (status) {
    case 'valid':
      return 'bg-green-50 border-green-200';
    case 'incomplete':
      return 'bg-yellow-50 border-yellow-200';
    case 'invalid':
      return 'bg-red-50 border-red-200';
    default:
      return 'bg-gray-50 border-gray-200';
  }
};
